var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"area-setting-close-button h-full",on:{"click":_vm.onClickClose}},[_c('close-icon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }